import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './hero.css'

const Hero = (props) => {
  return (
    <div
      id={props.hero17Id}
      className={`hero-thq-header78-elm ${props.rootClassName} `}
    >
      <div className="hero-thq-column-elm thq-section-max-width thq-section-padding">
        <div className="hero-thq-content-elm1">
          <h1 className="hero-thq-text-elm1 thq-heading-1">
            {props.heading1 ?? (
              <Fragment>
                <span className="hero-text4">
                  24/7 Professional Towing Services
                </span>
              </Fragment>
            )}
          </h1>
          <p className="hero-thq-text-elm2 thq-body-large">
            {props.content1 ?? (
              <Fragment>
                <span className="hero-text2">
                  Reliable and efficient towing services for vehicles of all
                  sizes and complexities. Trust Evac to be there for you
                  whenever you need us.
                </span>
              </Fragment>
            )}
          </p>
        </div>
        <a
          href="tel:+380932979737"
          className="hero-thq-action2-elm thq-button-animated thq-button-outline"
        >
          <span>
            {props.action21 ?? (
              <Fragment>
                <span className="hero-text3">Call Now</span>
              </Fragment>
            )}
          </span>
        </a>
      </div>
      <div className="hero-thq-content-elm2">
        <div className="hero-thq-row-container-elm1 thq-mask-image-horizontal thq-animated-group-container-horizontal">
          <div className="thq-animated-group-horizontal">
            <img
              alt={props.image1Alt}
              src={props.image1Src}
              className="hero-thq-placeholder-image-elm10 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image2Alt}
              src={props.image2Src}
              className="hero-thq-placeholder-image-elm11 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image3Alt}
              src={props.image3Src}
              className="hero-thq-placeholder-image-elm12 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image4Alt}
              src={props.image4Src}
              className="hero-thq-placeholder-image-elm13 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image5Alt}
              src={props.image5Src}
              className="hero-thq-placeholder-image-elm14 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image6Alt}
              src={props.image6Src}
              className="hero-thq-placeholder-image-elm15 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
          <div className="thq-animated-group-horizontal">
            <img
              alt={props.image1Alt}
              src={props.image1Src}
              className="hero-thq-placeholder-image-elm16 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image2Alt}
              src={props.image2Src}
              className="hero-thq-placeholder-image-elm17 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image3Alt}
              src={props.image3Src}
              className="hero-thq-placeholder-image-elm18 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image4Alt}
              src={props.image4Src}
              className="hero-thq-placeholder-image-elm19 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image5Alt}
              src={props.image5Src}
              className="hero-thq-placeholder-image-elm20 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              src="https://images.unsplash.com/photo-1555737202-2e86ace3b68f?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODYzOXw&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1500"
              className="hero-thq-placeholder-image-elm21 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
        <div className="hero-thq-row-container-elm2 thq-mask-image-horizontal thq-animated-group-container-horizontal">
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={props.image7Alt}
              src={props.image7Src}
              className="hero-thq-placeholder-image-elm22 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image8Alt}
              src={props.image8Src}
              className="hero-thq-placeholder-image-elm23 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image9Alt}
              src={props.image9Src}
              className="hero-thq-placeholder-image-elm24 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image10Alt}
              src={props.image10Src}
              className="hero-thq-placeholder-image-elm25 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image11Alt}
              src={props.image11Src}
              className="hero-thq-placeholder-image-elm26 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image12Alt}
              src={props.image12Src}
              className="hero-thq-placeholder-image-elm27 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={props.image7Alt}
              src={props.image7Src}
              className="hero-thq-placeholder-image-elm28 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image8Alt}
              src={props.image8Src}
              className="hero-thq-placeholder-image-elm29 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image9Alt}
              src={props.image9Src}
              className="hero-thq-placeholder-image-elm30 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image10Alt}
              src={props.image10Src}
              className="hero-thq-placeholder-image-elm31 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt={props.image11Alt}
              src={props.image11Src}
              className="hero-thq-placeholder-image-elm32 thq-img-scale thq-img-ratio-1-1"
            />
            <img
              alt="Hero Image"
              src="https://images.unsplash.com/photo-1529955169862-51fc083b42dc?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODY0Mnw&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1500"
              className="hero-thq-placeholder-image-elm33 thq-img-scale thq-img-ratio-1-1"
            />
          </div>
        </div>
      </div>
      <div>
        <div className="hero-container2">
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Hero.defaultProps = {
  image1Src:
    'https://images.unsplash.com/photo-1561043833-a50853391dd4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwNXw&ixlib=rb-4.1.0&q=80&w=1500',
  image12Src:
    'https://images.unsplash.com/photo-1542962302-7019cec5ae21?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwNHw&ixlib=rb-4.1.0&q=80&w=1500',
  image2Alt: 'Professional team providing towing service',
  image11Alt: 'Efficient towing solutions',
  image8Src:
    'https://images.unsplash.com/photo-1719772692993-933047b8ea4a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwNHw&ixlib=rb-4.1.0&q=80&w=1500',
  image7Alt: 'Fast and reliable towing solutions',
  image5Src:
    'https://images.unsplash.com/photo-1659256297426-cb50e6a36fd8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwNHw&ixlib=rb-4.1.0&q=80&w=1500',
  image9Src:
    'https://images.unsplash.com/photo-1696243144290-792f1f48339e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwNHw&ixlib=rb-4.1.0&q=80&w=1500',
  image8Alt: 'Dependable towing services',
  image6Src:
    'https://images.unsplash.com/photo-1461897104016-0b3b00cc81ee?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwM3w&ixlib=rb-4.1.0&q=80&w=1500',
  image1Alt: 'Towing truck on the road',
  image4Src:
    'https://images.unsplash.com/photo-1549923746-c502d488b3ea?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwNHw&ixlib=rb-4.1.0&q=80&w=1500',
  image4Alt: 'Close-up of towing equipment',
  image7Src:
    'https://images.unsplash.com/photo-1536336076412-fd2a4de236f0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwM3w&ixlib=rb-4.1.0&q=80&w=1500',
  image11Src:
    'https://images.unsplash.com/photo-1473603477862-9d352d4615e1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwM3w&ixlib=rb-4.1.0&q=80&w=1500',
  image10Alt: 'Professional towing team at work',
  image6Alt: 'Emergency towing assistance',
  content1: undefined,
  rootClassName: '',
  image3Alt: 'Towing truck assisting a stranded vehicle',
  image9Alt: '24/7 towing assistance',
  image2Src:
    'https://images.unsplash.com/photo-1534748626724-c6256f106a08?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwM3w&ixlib=rb-4.1.0&q=80&w=1500',
  image5Alt: 'Responsive towing services',
  action21: undefined,
  heading1: undefined,
  image12Alt: 'Trustworthy towing service provider',
  hero17Id: '',
  image10Src:
    'https://images.unsplash.com/photo-1560215978-9054e9c7b983?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwNXw&ixlib=rb-4.1.0&q=80&w=1500',
  image3Src:
    'https://images.unsplash.com/photo-1544967960-7215be35806f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc0NzI0ODEwMnw&ixlib=rb-4.1.0&q=80&w=1500',
}

Hero.propTypes = {
  image1Src: PropTypes.string,
  image12Src: PropTypes.string,
  image2Alt: PropTypes.string,
  image11Alt: PropTypes.string,
  image8Src: PropTypes.string,
  image7Alt: PropTypes.string,
  image5Src: PropTypes.string,
  image9Src: PropTypes.string,
  image8Alt: PropTypes.string,
  image6Src: PropTypes.string,
  image1Alt: PropTypes.string,
  image4Src: PropTypes.string,
  image4Alt: PropTypes.string,
  image7Src: PropTypes.string,
  image11Src: PropTypes.string,
  image10Alt: PropTypes.string,
  image6Alt: PropTypes.string,
  content1: PropTypes.element,
  rootClassName: PropTypes.string,
  image3Alt: PropTypes.string,
  image9Alt: PropTypes.string,
  image2Src: PropTypes.string,
  image5Alt: PropTypes.string,
  action21: PropTypes.element,
  heading1: PropTypes.element,
  image12Alt: PropTypes.string,
  hero17Id: PropTypes.string,
  image10Src: PropTypes.string,
  image3Src: PropTypes.string,
}

export default Hero
